/* eslint-disable no-await-in-loop */ // retry logic is a valid use

interface Options {
  maxRetries: number;
  onError?: (e: Error, retryCount: number) => void;
}

const wait = (waitSeconds: number) =>
  new Promise<void>(resolve => {
    setTimeout(resolve, waitSeconds * 1000);
  });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const runWithRetry = async <F extends () => Promise<any>>(
  func: F,
  { maxRetries, onError }: Options,
): Promise<F extends () => Promise<infer T> ? T : never> => {
  let retryCount = 0;
  let error: Error | null = null;
  while (retryCount < maxRetries) {
    try {
      return await func();
    } catch (e) {
      error = e instanceof Error ? e : new Error(`${e}`);
      if (onError) onError(error, retryCount);
      await wait(retryCount <= 0 ? 1 : retryCount * 2); // exponential backoff
      retryCount += 1;
    }
  }
  throw error;
};
